import { ContentTileFieldsFragment } from "@src/generated/graphql";
import { highlightBracketedText } from "src/utils/utils";

type ContentTileComponentProps = {
  content: ContentTileFieldsFragment;
};

const ContentTileComponent = ({ content }: ContentTileComponentProps) => {
  const { title, text, image } = content;

  const reverseLayout = false; 

  return (
    <section className="marketing-content-component">
      <div className="container-fluid custom-spacer-col">
        <div
          className={`row align-items-center justify-content-center ${reverseLayout ? "flex-row-reverse" : ""}`}
        >
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ gap: "20px" }}
          >
            <div className="mx-w-770 text-center">
              <span
                className="highlight-bracket-text"
                dangerouslySetInnerHTML={{
                  __html: highlightBracketedText(content?.title ?? "" , "bold"),
                }}
              />
            </div>
            <div className="mx-w-770 home-details text-center">
              <span
              className="content-tile-value regular"
              >
                {content?.text?.json?.content[0]?.content[0]?.value}
              </span>
            </div>
            <div className="mx-w-770 text-center">
              <span
                className="content-tile-description bold"
              >
                {content?.text?.json?.content[1]?.content[0]?.value}
              </span>
            </div>

            <div className="section-line">
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentTileComponent;
